import mutedIcon from "./player/muted.svg";

const Muted = () => <img src={mutedIcon} alt="" aria-hidden="true" />;

export default Muted
